import { createStandardAction } from 'typesafe-actions';

import { FetchKeysStoreKey } from '../reducers/createFetchKeysReducer';

const updateFetchKey = createStandardAction('updateFetchKey')<FetchKeysStoreKey>();

export default updateFetchKey;
